import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { Task, TASK_ROW_BORDER, TaskStatus } from '../../types/work';
import { WorkStatusBadge } from './WorkStatusBadge';
import { PriorityChip } from './PriorityChip';
import { DueDateLabel } from './DueDateLabel';

interface Props {
  task: Task;
  onClick: () => void;
  onStatusChange?: (newStatus: TaskStatus) => void;
}

export const TaskCard: React.FC<Props> = ({ task, onClick, onStatusChange }) => {
  const { darkMode } = useTheme();
  const borderClass = TASK_ROW_BORDER[task.status] || 'border-l-2 border-l-gray-600/30';
  const isCompleted = task.status === 'completed';

  return (
    <div
      onClick={onClick}
      className={`rounded-lg ${borderClass} border overflow-hidden cursor-pointer transition-all duration-200 hover:-translate-y-px ${
        darkMode ? 'bg-gray-800 border-gray-700 hover:bg-gray-700/80' : 'bg-white border-gray-200 hover:bg-gray-50'
      } ${isCompleted ? 'opacity-60' : ''}`}
      style={{ minHeight: '80px' }}
    >
      <div className="px-3 py-2.5 flex items-center gap-3">
        <div className="flex-1 min-w-0">
          <p className={`text-sm font-medium truncate ${isCompleted ? 'line-through' : ''} ${darkMode ? 'text-white' : 'text-gray-900'}`}>
            {task.title}
          </p>
          <div className="flex items-center gap-2 mt-1">
            <WorkStatusBadge status={task.status} clickable={!!onStatusChange} onCycle={onStatusChange} />
            <PriorityChip priority={task.priority} />
          </div>
        </div>
        <DueDateLabel date={task.due_date} />
      </div>
    </div>
  );
};
